import { render, staticRenderFns } from "./chart-documents-errors.vue?vue&type=template&id=73dc41fa&scoped=true&lang=pug&"
import script from "./chart-documents-errors.vue?vue&type=script&lang=ts&"
export * from "./chart-documents-errors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc41fa",
  null
  
)

export default component.exports